import { render, staticRenderFns } from "./platform-fee-rate-system.vue?vue&type=template&id=210b59e2&scoped=true&"
import script from "./platform-fee-rate-system.vue?vue&type=script&lang=js&"
export * from "./platform-fee-rate-system.vue?vue&type=script&lang=js&"
import style0 from "./platform-fee-rate-system.vue?vue&type=style&index=0&id=210b59e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b59e2",
  null
  
)

export default component.exports